export class KeyspacesBackupConfigApplication {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "readCapacityUnitsRequired",
            "baseName": "readCapacityUnitsRequired",
            "type": "number",
            "format": ""
        },
        {
            "name": "isAutoscaleEnabled",
            "baseName": "isAutoscaleEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "maxReadCapacityUnits",
            "baseName": "maxReadCapacityUnits",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KeyspacesBackupConfigApplication.attributeTypeMap;
    }
    constructor() {
    }
}
